import { rem } from "@mantine/core";

import { ThemeComponent } from "./helpers.ts";

export default function codeTheme(): ThemeComponent {
  return {
    styles: {
      root: {
        fontSize: rem(16),
      },
    },
  };
}
